module.exports = __webpack_public_path__ + "static/icon-payment-americanexpress-ae26c4853cd95e7a0e9ad4005395d257.svg";